import {Route, Routes, Outlet, Navigate} from 'react-router-dom'
import {ErrorBatchesList} from './error-batches-list/ErrorBatchesList'
import {ErrorBatchesDetail} from './error-batches-detail/BatchDetail'

export const ErrorBatchesPage = () => {
  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          path='/list'
          element={
            <>
              <ErrorBatchesList />
            </>
          }
        />
        <Route
          path='/:id/detail'
          element={
            <>
              <ErrorBatchesDetail />
            </>
          }
        />
      </Route>
      <Route index element={<Navigate to='/errors/list' />} />
    </Routes>
  )
}
